{% block swag_migration_history %}
    <mt-card
        class="swag-migration-history"
        :is-loading="isLoading"
        :large="true"
        position-identifier="swag-migration-history"
    >
        <template #grid>
            {% block swag_migration_history_grid %}
                <sw-data-grid
                    v-if="migrationRuns.length > 0"
                    identifier="swag-migration-history"
                    :data-source="migrationRuns"
                    :columns="migrationColumns"
                    :show-selection="false"
                    :show-settings="true"
                    :allow-column-edit="true"
                    :sort-by="sortBy"
                    :sort-direction="sortDirection"
                    @column-sort="onSortColumn"
                >
                    {% block swag_migration_history_grid_column_status %}
                        <template #column-step="{ item }">
                            <mt-icon v-if="item.step === 'finished'"
                                     class="swag-migration-history__status-icon swag-migration-history__status-icon--finished"
                                     name="regular-checkmark"
                                     size="16px" />
                            <mt-icon v-else-if="item.step === 'aborted'"
                                     class="swag-migration-history__status-icon swag-migration-history__status-icon--aborted"
                                     name="regular-times"
                                     size="16px" />
                            <mt-icon v-else-if="item.step === 'running'"
                                     class="swag-migration-history__status-icon swag-migration-history__status-icon--loading"
                                     name="regular-circle"
                                     size="16px" />
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_column_profile %}
                        <template #column-connection.profile="{ item }">
                            {{ item.connection.profileName }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_column_gateway %}
                        <template #column-connection.gateway="{ item }">
                            {{ item.connection.gatewayName }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_column_createdAt %}
                        <template #column-createdAt="{ item }">
                            {{ dateFilter(item.createdAt, migrationDateOptions) }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_column_sourceSystemName %}
                        <template #column-environmentInformation.sourceSystemName="{ item }">
                            {{ item.environmentInformation.sourceSystemName }}
                            {{ item.environmentInformation.sourceSystemVersion }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_actions %}
                        <template #actions="{ item }">
                            <sw-context-menu-item :router-link="{ name: 'swag.migration.index.history.detail', params:{ id:item.id } }">
                                {{ $tc('swag-migration.history.contextMenu.details') }}
                            </sw-context-menu-item>

                            <sw-context-menu-item @click="onContextDownloadLogFile(item.id)">
                                {{ $tc('swag-migration.history.contextMenu.downloadLogs') }}
                            </sw-context-menu-item>
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_grid_pagination %}
                        <template #pagination>
                                <sw-pagination :page="page"
                                               :limit="limit"
                                               :total="total"
                                               :total-visible="7"
                                               @page-change="onPageChange" />
                        </template>
                    {% endblock %}
                </sw-data-grid>
            {% endblock %}

            {% block swag_migration_history_router_view %}
                <router-view />
            {% endblock %}

            {% block swag_migration_history_log_download_form %}
                <form ref="downloadLogsOfRunForm"
                      class="swag-migration-history-detail-errors__download-form"
                      :action="logDownloadEndpoint"
                      method="POST">
                    <input type="hidden"
                           name="runUuid"
                           :value="runIdForLogDownload">
                </form>
            {% endblock %}

        </template>
    </mt-card>
{% endblock %}
